import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Advisors)',
  collection: {
    endpoint: '/api/admin/truevail/admin/advisors',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Advisor)', key: 'team.title', sort: 'title',  primary: true, format: (advisor) => (
        <TeamToken { ..._.omit(advisor.team, 'is_active') } />
      ) },
      { label: 't(Agency)', key: 'agency.team.title', sort: 'agency' },
      { label: 't(Status)', key: 'team.status', sort: 'status', collapsing: true, format: StatusToken }
    ],
    export: [
      { label: 't(ID)', key: 'id' },
      { label: 't(Advisor)', key: 'team.title' },
      { label: 't(Agency)', key: 'agency.team.title' },
      { label: 't(First Name)', key: 'team.primary_user.provider_contact.first_name' },
      { label: 't(Last Name)', key: 'team.primary_user.provider_contact.last_name' },
      { label: 't(Email)', key: 'team.primary_user.provider_contact.email' },
      { label: 't(Tags)', key: 'team.primary_user.provider_contact.tags' },
      { label: 't(Canceled On)', key: 'team.subscription.canceled_on' },
      { label: 't(Status)', key: 'team.status' }

    ],
    defaultSort: { key: 'title', order: 'asc' },
    criteria: {
      system: [
        { id: 0, title: 't(Active Advisors)', config: {
          criteria: [
            { code: 'abc', data: null, field: 'status', operator: '$eq', parent: null, value: 'active' }
          ]
        } },
        { id: 0, title: 't(Pending Advisors)', config: {
          criteria: [
            { code: 'abc', data: null, field: 'status', operator: '$eq', parent: null, value: 'pending' }
          ]
        } },
        { id: 1, title: 't(Configured Advisors)', config: {
          criteria: [
            { code: 'abc', data: null, field: 'status', operator: '$eq', parent: null, value: 'configured' }
          ]
        } },
        { id: 1, title: 't(Delayed Advisors)', config: {
          criteria: [
            { code: 'abc', data: null, field: 'status', operator: '$eq', parent: null, value: 'delayed' }
          ]
        } },
        { id: 1, title: 't(Unconfigured Advisors)', config: {
          criteria: [
            { code: 'abc', data: null, field: 'status', operator: '$eq', parent: null, value: 'unconfigured' }
          ]
        } }
      ],
      fields: [
        { label: 't(Advisor)', fields: [
          { name: 'Agency', key: 'agency_id', type: 'select', endpoint: '/api/admin/truevail/admin/agencies', valueKey: 'id', textKey: 'organization', format: (advisor) => (
            <TeamToken { ..._.omit(advisor.team, 'is_active') } />
          ) },
          { name: 'Billing Plan', key: 'plan_id', type: 'select', endpoint: '/api/admin/subscriptions/services/3/plans', valueKey: 'id', textKey: 'title' },
          { name: 'Subscription Type', key: 'subscription_type', type: 'select', options: [
            { value: 'email', text: 't(Email)' },
            { value: 'social', text: 't(Social)' },
            { value: 'legacy_website', text: 't(Legacy Website)' }
          ] },
          { name: 'Status', key: 'status', type: 'select', options: ['pending','configured','delayed','active','paused','canceled','inactive','unconfigured'], format: StatusToken  }
        ] }
      ]
    },
    empty: {
      svg: 'user_round',
      title: 't(No Advisors)',
      text: 't(You have not yet created any advisors)'
    },
    entity: 'advisor',
    onClick: (record) => context.router.push(`/admin/truevail/admin/advisors/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
